/* eslint-disable import/prefer-default-export */
import { DIVISIONS_LIST, GROUPS_LIST, DEPARTMENTS_LIST } from 'constants';
import _camelCase from 'lodash/camelCase';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import without from 'lodash/without';
import { priceFormatter } from 'utils';

export const getDepartmentNameById = (id) => DIVISIONS_LIST[id] || 'Department not found';

export const getSalesItemName = (id) => {
  const name = DIVISIONS_LIST[id] || GROUPS_LIST[id] || DEPARTMENTS_LIST[id];
  const number = DIVISIONS_LIST[id] ? '' : `${id} `;
  return name ? `${number}${name}` : null;
};

export const getSalesItemNamePerType = (type, id) => {
  let name;

  switch (type) {
    case 'division':
      name = DIVISIONS_LIST[id];
      break;

    case 'group':
      name = GROUPS_LIST[id];
      break;

    case 'department':
      name = DEPARTMENTS_LIST[id];
      break;

    default:
      name = null;
  }

  const number = DIVISIONS_LIST[id] ? '' : `${id} `;
  return name ? `${number}${name}` : null;
};

export const getGroupAndDivisionIdsFromExpandedNodes = (expandedNodes) => {
  const currentNodeId = expandedNodes[0];
  const groupId = GROUPS_LIST[currentNodeId] && currentNodeId;
  const divisionId = expandedNodes.find((nodeId) => DIVISIONS_LIST[nodeId]);

  return {
    groupId,
    divisionId,
  };
};

export const mapDepartmentIdToName = (data = {}) => {
  return data
    ?.map((item) => ({
      departmentName: getDepartmentNameById(item?.id),
      departmentId: item?.id,
      departmentRevenue: item?.value,
    }))
    .reduce(
      (acc, curr) =>
        acc.findIndex((deptItem) => deptItem.departmentId === curr.departmentId) < 0 ? [...acc, curr] : acc,
      [],
    );
};

export const mapDivisionCodeToDepartmentName = (divisionList = []) =>
  divisionList.map((item) => ({ ...item, value: DIVISIONS_LIST[item.key] }));

export const adjustPerformanceParams = (options) => {
  const params = {};
  return Object.entries(options).reduce((option, [key, value]) => {
    switch (key) {
      case 'fromDate':
        params.dateFrom = value;
        break;
      case 'toDate':
        params.dateTo = value;
        break;
      case 'filters':
        params.filter = { ...value };
        break;
      case 'pagination':
        params.pagination = { ...value };
        break;
      default:
        break;
    }
    return params;
  }, {});
};

export const refineRemindersBySectionsAndSort = (reminders) => {
  // ToDo: replace moment with better library
  const sortedReminders = sortBy(reminders, [
    ({ reminderIsoDate }) => moment(reminderIsoDate),
    ({ createdIsoDateTime }) => moment(createdIsoDateTime),
  ]);
  const completedReminders = sortedReminders.filter(({ completed }) => completed);
  const todayAndPastReminders = sortedReminders.filter(({ reminderIsoDate }) => {
    // Moment returns 0 difference for today and tomorrow. So isSameDay check is needed.
    const isSameDay = moment(reminderIsoDate).isSame(moment(), 'day');
    const daysDifference = moment(reminderIsoDate).diff(moment.now(), 'days');
    return daysDifference < 0 || (!daysDifference && isSameDay);
  });

  const todayUncompletedReminders = without(todayAndPastReminders, ...completedReminders);
  const upcomingReminders = without(sortedReminders, ...completedReminders, ...todayUncompletedReminders);

  return {
    todayUncompletedReminders,
    upcomingReminders,
    completedReminders,
  };
};

export const mpsFormatter = (data, style) => {
  switch (_camelCase(style)) {
    case 'netSales':
      return priceFormatter(data);
    case 'wardrobing':
      return data;
    case 'clientConnect':
    case 'clientConnectsConversion':
      return `${data}%`;
    default:
      return data;
  }
};
